import type { Condition } from 'types';
import { baseQuery } from '../baseQuery';

export type TechnicianAvailability = {
  status: 'Y' | 'J' | 'N' | 'C' | 'A';
  job:
    | {
        job_id: number;
        customer_suburb_id: number;
        job_description: string;
        reschedule_status: string;
        notified: string;
        type: 'O' | 'R';
        warranty: Condition;
        /* in seconds */
        appointment_duration: number;
        appointment_end: number; // timestamp
      }
    | never[];
  service: never[] | Record<string, unknown>;
  recurring: boolean;
};

type Date = string;
type Time = string;

export type AvailabilityCalendar<T> = Record<Date, Record<Time, T>>;

export const getTechnicianAvailability = async (
  technicianId: number | string,
  startDate: string,
  numberOfDays: number = 31,
) => {
  const { data } = await baseQuery(
    `technicians/${technicianId}/availability?start_date=${startDate}&days=${numberOfDays}`,
  );

  return data as AvailabilityCalendar<TechnicianAvailability>;
};
